import gql from 'graphql-tag';

import * as loggerx from 'utilities/loggerx';

import { getGraphQLClient } from './graphql';
import { ORG_ROLE_ADMIN } from '../../../shared/constants/organizationRoles';

export const MEMBER_TYPE_ACCEPTED = 'accepted';
export const MEMBER_TYPE_INVITED = 'invited';

export const TRANFER_ADMIN_ROLE = gql`
  mutation ($userIdTo: ID!) {
    transferAdminStatusToAnotherMember(userIdTo: $userIdTo) {
      ... on TransferAdminStatusToAnotherMemberResult {
        success
        message
      }
    }
  }
`;

export const requestAdminRoleTransferForCurrentWorkspace = async userIdTo => {
  const gqlClient = getGraphQLClient();

  try {
    const { data } = await gqlClient.mutate({
      mutation: TRANFER_ADMIN_ROLE,
      variables: {
        userIdTo,
      },
    });

    return data;
  } catch (err) {
    loggerx.error(err, 'Unable to transfer admin status', {
      userIdTo,
    });

    throw err;
  }
};

export const isOnlyTeamAdmin = workspace => {
  if (!workspace) {
    return false;
  }

  return (
    workspace.memberRole === ORG_ROLE_ADMIN &&
    workspace.totalAdminCount === 1 &&
    workspace.members > 1
  );
};
